import React from 'react'
import { Route, Routes } from 'react-router-dom'
import SideBar from '../Components/Sidebar/SideBar'
import Dashboard from '../Pages/Dashboard'
import Login from '../Pages/Login'
import { useSelector } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import Admin from '../Pages/Admin'
import Role from '../Components/Settings/Role'
import Company from '../Components/Settings/Company'
import Employees from '../Pages/Employees'
import Lead1 from '../Components/Leads/Lead1'
import Lead2 from '../Components/Leads/Lead2'
import Profile from '../Pages/Profile'
import LeadsGroups from '../Components/Groups/LeadsGroups'
import ViewGroups from '../Components/Groups/ViewGroups'
import ViewGroupDetails  from '../Pages/ViewGroupDetails'
import TeamLeadsDetails from '../Pages/TeamLeadsDetails'
import TotalLeads from '../Pages/TotalLeads';
import TeamChanges from '../Components/Settings/TeamChanges'
import UserReport from '../Pages/UserReport'
import TeamHeirachy from '../Pages/EmployeeChart/TeamHeirachy'
import Attendence from '../Pages/Attendence'
import Mispunch from '../Pages/Mispunch'
import TeamAttendence from '../Pages/TeamAttendence'
import EmployeeStatus from '../Pages/EmployeeStatus/Employestatus';
import TalkTime from '../Pages/TalkTime/TalkTime';
import NewLogin from '../Pages/NewLogin'

export default function ProjectRoute() {

    const islogin = useSelector(state => state?.login?.isLoggedIn)
    return (
        <>
            {
                islogin ?
                    <SideBar>
                        <Routes>
                            <Route path="" element={<Dashboard />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="/role" element={<Role />} />
                            <Route path="/company" element={<Company />} />
                            <Route path="/user" element={<Employees />} />
                            <Route path="/lead1" element={<Lead1 />} />
                            <Route path="/lead2" element={<Lead2 />} />
                            <Route path='/empreport' element={<UserReport/>}/>
                            <Route path='/employee-tree' element={<TeamHeirachy/>}/>
                            <Route path='/Own-Attendence' element={<Attendence/>}/>
                            <Route path='/Team-Attendence' element={<TeamAttendence/>}/>
                            <Route path='/Mispunch' element={<Mispunch/>}/>
                            <Route path='/profile' element={<Profile/>}/>
                            <Route path="/view-groups" element={<ViewGroups/>} />
                            <Route path="/leads-groups" element={<LeadsGroups/>} />
                            <Route path="/detail-groups" element={<ViewGroupDetails/>}/>
                            <Route path="/teamleads-detail" element={<TeamLeadsDetails/>}/>
                            <Route path='/total-leads' element={<TotalLeads/>}/>
                            <Route path='/team-changes' element={<TeamChanges/>}/>
                            <Route path='/emp-status' element={<EmployeeStatus/>}/>
                            <Route path='/talk-time' element={<TalkTime/>}/>

                        </Routes>
                    </SideBar>
                    :
                    <Routes>
                        <Route path="" element={<NewLogin />} />
                    </Routes>
            }
            <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={true}
                theme="light" />
        </>
    )
}
